import { render, staticRenderFns } from "./quarterProduct.vue?vue&type=template&id=457b2021&scoped=true"
import script from "./quarterProduct.vue?vue&type=script&lang=js"
export * from "./quarterProduct.vue?vue&type=script&lang=js"
import style0 from "./quarterProduct.vue?vue&type=style&index=0&id=457b2021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457b2021",
  null
  
)

export default component.exports